import { AlertController } from 'ionic-angular';
import { Apollo } from 'apollo-angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage';

import { Task, TaskQL, TaskData } from './models';
import { TASKS_QUERY } from './queries';
import { ENV } from '../../environments/environment';
import { User } from './../auth/models';
import { AuthProvider } from './../auth/auth';
import { UtilsProvider } from './../utils/utils';
import { getValue } from './filters';

@Injectable()
export class TasksProvider {
  private tasksQL: TaskQL[];
  private tasksData: TaskData[] = [];
  private selectedTask: TaskQL;

  constructor(
    public http: HttpClient,
    private apollo: Apollo,
    private utils: UtilsProvider,
    private authProvider: AuthProvider,
    private utilsProvider: UtilsProvider,
    private storage: Storage,
    private alertCtrl: AlertController
  ) {
    this.storage
      .get('tasksData')
      .then(result => {
        console.log('STORAGE RESULT:: ', result);
        // this.tasksData = result ? result : {};
        // this.tasksData =  {};
      })
      .catch(e => console.log(e));
  }

  public getTasks(
    params: {
      lookAfter?: any;
      lookBefore?: any;
      limit?: number;
      statuses?: string[];
      fullText?: string;
      contract?: string;
      startDate?: number;
      endDate?: number;
      sortFilter?: any;
      filters?: any;
    } = {
      lookAfter: null,
      lookBefore: null,
      startDate: 0,
      endDate: new Date().setHours(23, 59, 59, 999),
      limit: null,
      fullText: null,
      contract: null,
      statuses: [],
      sortFilter: { field: 'createdDate', direction: 'DESC' },
      filters: null
    },
    currentUser: boolean = true
  ) {
    return Observable.create(obs => {
      if (!params.statuses || params.statuses.length === 0) delete params.statuses; // = [Task.StatusEnum.Cancelled,Task.StatusEnum.Closed,Task.StatusEnum.Deleted,Task.StatusEnum.Inprogress,Task.StatusEnum.New,Task.StatusEnum.Open,Task.StatusEnum.Pending,Task.StatusEnum.Pending,Task.StatusEnum]
      let filter = {
        ...params
      };

      if (!filter.sortFilter)
        filter.sortFilter = {
          field: 'assignedDate',
          direction: 'ASC'
        };
      const defaultFilters = {
        userId: { _in: this.authProvider.getUserId() }
      };

      if(currentUser) filter.filters = { ...params.filters, ...defaultFilters };

      this.authProvider.initGraphQL().subscribe(
        graphResult => {
          this.apollo
            .query<any>({
              query: TASKS_QUERY,
              variables: filter
            })
            .subscribe(
              r => {
                const tasksQL = [...(r as any).data.tasks.items];
                const info = r.data.tasks;

                  if(currentUser){
                    this.tasksQL = tasksQL;
                    this.syncTasksData();
                  }
                  obs.next({
                  items: tasksQL,
                  totalCount: info.totalCount,
                  nextLookAfterKey: info.nextLookAfterKey,
                  previousLookBeforeKey: info.previousLookBeforeKey
                });
              },
              e => {
                this.utils.handleGraphError(e, true);
                obs.error(e);
              }
            );
        },
        error => {
          obs.error(error);
        }
      );
    });
  }

  public syncTasksData() {
    // TODO syncing
    for (var key in this.tasksData) {
      if (this.tasksData.hasOwnProperty(key)) {
        const hasTask: boolean =
          this.tasksQL.filter(taskQL => {
            return taskQL.id === key;
          }).length > 0;

        if (!hasTask) {
          delete this.tasksData[key];
        }
      }
    }
    this.storage.set('tasksData', this.tasksData).then((value: any) => {
      // store tasksData again
    });
  }

  public getTask(id: string) {
    return Observable.create(obs => {
      this.authProvider.getOptions().subscribe(options => {
        // /api/users/:id
        let api = ENV.api + '/api/tasks/' + id;
        this.http.get(api, options).subscribe(
          result => {
            obs.next(result);
          },
          error => {
            this.utilsProvider.handleAPIError(error);
          }
        );
      });
    });
  }

  public updateToInprog(task: TaskQL) {
    return Observable.create(obs => {
      this.getTask(task.id).subscribe((taskResult: Task) => {
        if(taskResult.status !== Task.StatusEnum.Inprogress){
          taskResult.status = Task.StatusEnum.Inprogress;
        }
        if(!taskResult.install){
          taskResult.status = Task.StatusEnum.Inprogress;
          taskResult.install = {serial:'10000560GEYSER'}
        }
        this.updateTask(taskResult).subscribe(
          updateResult => {
            obs.next(updateResult);
          },err => {
              obs.next(err);
          })
      },err => {
          obs.next(err);
      })
    })
  }

  public updateTask(task: Task) {
    task = this.removeHttpFromOnboardingUrlTask(task);
    // takes a task and updates it
    return Observable.create(obs => {
      this.authProvider.getOptions().subscribe(options => {
        // /api/users/:id
        let api = ENV.api + '/api/tasks/' + task.id;
        this.http.put(api, task, options).subscribe(
          result => {
            obs.next(result);
          },
          error => {
            this.utilsProvider.handleAPIError(error);
          }
        );
      });
    });
  }

  public updateTaskPartial(id: string, partial: any, notes?: any[], complete?: boolean) {
    return Observable.create(obs => {
      this.authProvider.getOptions().subscribe(options => {
        // /api/users/:id
        let api = ENV.api + '/api/tasks/' + id;
        this.http.get(api, options).subscribe(
          taskResult => {
            if (partial.install && (taskResult as any).install) {
               partial.install = {
                ...(taskResult as any).install,
                ...partial.install
              };
            }
            const task = { ...taskResult, ...partial };
            if (notes) {
              // if has notes add to notes
              task.notes = task.notes ? [...task.notes, ...notes] : [...notes];
            }
            // task['tryfail'] = true;
            if (task.address && !task.address.building) delete task.address.building;

            if (task.install && !task.install.activationPassword && task.install.serial.includes('FIRE') && complete) {
              task.install.activationPassword = localStorage.getItem('lastPass');
            }
              const parsedTask = this.removeHttpFromOnboardingUrlTask(task);
              // update: PUT
              this.http.put(api, parsedTask, options).subscribe(
                result => {
                  obs.next(result);
                },
                error => {
                  this.utilsProvider.handleAPIError(error);
                  obs.error(error);
                }
              );
          },
          error => {
            this.utilsProvider.handleAPIError(error);
            obs.error(error);
          }
        );
      });
    });
  }

  public setSelectedTask(task: TaskQL) {
    this.selectedTask = task;
  }
  public getSelectedTask(): TaskQL {
    return this.selectedTask;
  }

  public updateTaskData(task: TaskQL, type: string, data: any) {
    /* Update the stored data of the tasks */
    if (task.schedulerMeta && task.schedulerMeta != null) {
      task.schedulerMeta = {
        expiredTime: 0,
        acceptedSchedulerSnn: '',
      }
    }

    return Observable.create(observer => {
      if (!this.tasksData[task.id]) {
        this.tasksData[task.id] = {};
      }

      this.tasksData[task.id][type] = data;
      this.storage.set('tasksData', this.tasksData).then((value: any) => {
        observer.next(this.tasksData[task.id]);
      });
    });
  }

  public getTaskData(id: string) {
    return this.tasksData && this.tasksData[id] ? this.tasksData[id] : {};
  }

  cancelTask(taskQL: TaskQL, reason: string, attachments?: Array<any>): Observable<any> {
    // TODO: add user model data
    //       task update
    return Observable.create(obs => {
      const userData: User = this.authProvider.userData.data as User;
      let note = {
        timestamp: new Date().getTime(),
        note: 'Cancelled by user: ' + userData.userName + '(' + userData.email + ')',
        userId: userData.uid
      };
      if (reason) {
        note.note += ': ' + reason;
      }
      if (attachments && attachments.length > 0) {
        note.note += ':<br>' + this.utilsProvider.toHTMLlinks(attachments);
      }

      this.getTask(taskQL.id).subscribe((taskResult: Task) => {
        taskResult.status = Task.StatusEnum.ToReschedule;
        delete taskResult.assignedDate;
        if (!taskResult.notes) taskResult.notes = new Array();
        taskResult.notes.push(note);
        taskResult.cancellationReason = 'reason';
        this.updateTask(taskResult).subscribe(
          updateResult => {
            obs.next(updateResult);
            obs.complete();
            // TODO: remove from cache
            // this.removeFromTasks(id).subscribe(result => {
            //   console.log('got result from task remove');
            // });
          },
          error => {
            // obs.error('could not update');
            this.utilsProvider.handleAPIError(error);
          }
        );
      });
    });
  }

  public setTaskData(task: TaskQL, val: string, data: any) {
    return Observable.create(obs => {
      // TODO: save to cache (storage)
      obs.next('continue here');
    });
  }

  public setTask(task: Task) {}

  syncTask(taskData: TaskData, task: TaskQL): Observable<any> {
    let attachments = [];
    return Observable.create(observer => {

      observer.next({
        title: 'Uploading Images',
        message: 'image 1',
        percent: 10
      });
      if (task.deviceType !== 'firealarm' && taskData.photos && taskData.photos.length > 0) {
        //upload images
        const photos = [...taskData.photos].filter(pic => pic.data)
        this.utilsProvider.uploadImages(photos, 0, null, task.id).subscribe(
          response => {
            attachments.push(response.data);
            observer.next({
              title: 'Uploading Images',
              message: 'image ' + (response.id + 2).toString(),
              percent: (response.id + 1) * 20
            });
          },
          error => {
            let message = 'Images could not be uploaded. Please try again.';
            let alert = this.alertCtrl.create({
              title: 'Error!',
              message: message,
              buttons: ['OK']
            });
            alert.present();
            observer.error(error);
          },
          () => {
            this.syncUpdatingTask(observer, task, taskData, attachments);
          }
        );
      } else {
        this.syncUpdatingTask(observer, task, taskData, attachments);
      }
    });
  }

  syncUpdatingTask(observer, task: TaskQL, taskData: TaskData, attachments: any[]) {
    observer.next({ title: 'Updating Task', message: '...' });

    // TODO: FIxup
    // if(task.type !== 'installation' && task.deviceType === 'geyser'){
      attachments = this.dummyFireData(attachments)
    // }
    let hasSerial = task.install.serial ? task.install.serial : null;
    let schedulerMeta = !task.schedulerMeta || task.schedulerMeta == null ?
      {
        expiredTime: 0,
        acceptedSchedulerSnn: '',
      } : task.schedulerMeta;
    let partial = {
      completedDate: new Date().getTime(),
      status: 'closed',
      install: {
        activationPassword: '',
        questionsAnswers: taskData.questions? this.parseQA(taskData.questions): [],
        customerFeedback: taskData.feedback ? taskData.feedback : '',
        images: attachments,
        serial: hasSerial
      },
      schedulerMeta: schedulerMeta
    };
    if (taskData.code && taskData.code.includes('=')) {
      partial.install.activationPassword = taskData.code.substring(taskData.code.indexOf('=') + 1);
    }

    let notes = [];
    if (taskData.comments) {
      for (let i = 0; i < taskData.comments.length; i++) {
        let comment = taskData.comments[i];
        if (comment && comment.length > 0) {
          notes = new Array();
        }
      }
    }

    if (taskData.newSerial && taskData.deviceReplace) {
      partial.install['newSerial'] = taskData.newSerial;
    }

    if (taskData.code && taskData.code.includes(';')) {
      const pass = taskData.code.substring(taskData.code.indexOf(';') + 5);
      partial.install.activationPassword = pass;
    }

    observer.next({
      title: 'Updating',
      message: 'Sending',
      percent: 90
    });

    if(taskData.feedback) {
      const userData: User = this.authProvider.userData.data as User;
      let note = {
        timestamp: new Date().getTime(),
        note: taskData.feedback,
        userId: userData.uid
      };
      notes.push(note)
    }
    this.updateTaskPartial(task.id, partial, notes, true).subscribe(
      updateResult => {
        observer.next({
          title: 'Updating',
          message: 'done',
          percent: 100
        });
        observer.complete();
      },
      error => {
        partial.status = 'inprogress';
        // let message =
        //   error.error && error.error.error && error.error.error.message
        //     ? error.error.error.message +
        //       '. Task could not be updated. Please try again.'
        //     : 'Task could not be updated. Please try again.';
        // let alert = this.alertCtrl.create({
        //   title: 'Error!',
        //   message: message,
        //   buttons: ['OK']
        // });
        // alert.present();
        observer.error(error);
      }
    );
  }

  parseQA(obj) {
    let qaObj: Array<any> = [];
    for (let i = 0; i < obj.length; i++) {
      let question = obj[i].label ? obj[i].label : obj[i].title;
      let answers = obj[i].options ? obj[i].options : obj[i].answers;
      let answer = '';
      let value: any = '';
      if (!obj.hidden) {
        if (obj[i].type === 'input') {
          answer = obj[i].value;
          value = obj[i].value;
        } else {
          for (var a = 0; a < answers.length; a++) {
            if (answers[a].selected) {
              answer = answers[a].title;
              value = answers[a].value;
            }
          }
        }
      }

      qaObj.push({
        question: question,
        answer: answer,
        tag: obj[i].tag,
        value: value
      });
    }
    return qaObj;
  }

  dummyFireData(attachments){
    const dummyPics = {
      comment: "",
      label: "",
      src: "sn-sensordesk-images-development.s3.eu-west-1.amazonaws.com/images/20210915132621-snn_account_6-1.jpg",
      tag: ""
    }
    if(attachments.length < 1){
      attachments = [dummyPics]
    }
    return attachments;
  }

  removeHttpFromOnboardingUrlTask(obj){
    const onboardingUrl =  getValue(obj,'companyReference.meta.geyser:contact.onboardingUrl');
     if(onboardingUrl){
       obj.companyReference.meta["geyser:contact"].onboardingUrl = onboardingUrl.replace('http://','');
     }

     obj.notes =  obj.notes.map(note => {
       note.note = note.note.replaceAll("http://", '').replaceAll("https://", '');
       return note;
     });
     return obj;
  }
}



// WEBPACK FOOTER //
// ./src/providers/tasks/tasks.ts